var map = {
	"./delivery.js": "f1f5",
	"./deliveryModal.js": "e5e1",
	"./home.js": "3886",
	"./navigation.js": "24ea",
	"./staffCost.js": "be27",
	"./staffHours.js": "48a1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "61a7";